/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import coverPlaceholder from "./cover-placeholder.svg";
import framePlaceholder from "./frame-placeholder.svg";
import squarePlaceholder from "./square-placeholder.svg";

export default {
  coverPlaceholder,
  framePlaceholder,
  squarePlaceholder,
};
